"use client";

import { useTranslations } from "next-intl";

import ErrorPage from "./ErrorPage";

interface PropertyErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
  propertyType?: "buy" | "rent" | "developer";
}

export default function PropertyErrorPage({
  error,
  reset,
  propertyType = "buy",
}: PropertyErrorPageProps) {
  const t = useTranslations("common");

  const getTitle = () => {
    switch (propertyType) {
      case "buy":
        return t("error_loading_property");
      case "rent":
        return t("error_loading_rental");
      case "developer":
        return t("error_loading_developer");
      default:
        return t("error_loading_property");
    }
  };

  const getDescription = () => {
    switch (propertyType) {
      case "buy":
        return t("property_loading_failed_description");
      case "rent":
        return t("rental_loading_failed_description");
      case "developer":
        return t("developer_loading_failed_description");
      default:
        return t("error_try_again_later");
    }
  };

  return (
    <ErrorPage
      error={error}
      reset={reset}
      title={getTitle()}
      description={getDescription()}
    />
  );
}
